<template>
  <MsSwitch
    :checked="false"
    :text="'Relative to seabed'"
    :id="'chartseabed'"
    @value-changed="(checked) => updateShowDelta(checked)"
  ></MsSwitch>
</template>

<script setup lang="ts">
import MsSwitch from '../../general/input/MsSwitch.vue'
import { defineEmits } from 'vue'

const emit = defineEmits(['show-delta'])

function updateShowDelta(newValue: boolean) {
  emit('show-delta', newValue)
}
</script>
